import {
    Grid,
    Tab,
    Box,
    Card,
    CardContent,
    Typography,
    CardActions,
    Button,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
    AccountCircle,
    PhoneIphone,
    Email,
    LocationOn,
    DataUsage,
    Apartment,
    MyLocation,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSingleLead, reset } from "../../Redux/LeadsSlice/LeadsSlice";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
const LeadInfo = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const { singleLead, isLodaing } = useSelector((state) => state.leads);
    const SINGLE_LEAD = singleLead?.data ? singleLead?.data?.lead : "";
    const SOLUTIONS = singleLead?.data ? singleLead?.data?.opportunities : [];
    const CONTRACT = singleLead?.data ? singleLead?.data?.solar_contract : [];

    //   console.log("SOLUTIONS", SOLUTIONS);
    //////////////////
    const [value, setValue] = useState("1");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // get the single leqd
    useEffect(() => {
        const getLead = async () => {
            await dispatch(getSingleLead(id));
            await dispatch(reset());
        };
        getLead();
    }, [id]);
    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <Grid container spacing={3} columns={12}>
                    <Grid item md={4}>
                        <LeadInfoStyled>
                            <div className="data">
                                <div className="heading">
                                    <AccountCircle />
                                </div>
                                <div className="lead_info">
                                    <AccountCircle />

                                    <p className="data">
                                        {SINGLE_LEAD?.first_name}{" "}
                                        {SINGLE_LEAD?.last_name}
                                    </p>
                                </div>
                                <div className="lead_info">
                                    <PhoneIphone />
                                    <p className="data">
                                        {SINGLE_LEAD?.mobile}
                                    </p>
                                </div>
                                <div className="lead_info">
                                    <Email />
                                    <p className="data">{SINGLE_LEAD?.email}</p>
                                </div>
                                <div className="lead_info">
                                    <LocationOn />
                                    <p className="data">
                                        {SINGLE_LEAD?.location}
                                    </p>
                                </div>

                                <div className="lead_info">
                                    <DataUsage />
                                    <p className="data">
                                        {SINGLE_LEAD?.building_type}
                                    </p>
                                </div>
                                <div className="lead_info">
                                    <DataUsage />
                                    <p className="data">
                                        {SINGLE_LEAD?.home_occupancy}
                                    </p>
                                </div>
                                <div className="lead_info">
                                    <Apartment />
                                    <p className="data">
                                        {SINGLE_LEAD?.customer_type}
                                    </p>
                                </div>
                                <div className="lead_info">
                                    <MyLocation />
                                    <p className="data">
                                        {SINGLE_LEAD?.zip_code}
                                    </p>
                                </div>
                                <div className="lead_info">
                                    <DataUsage />
                                    <p className="data">
                                        {SINGLE_LEAD?.status}
                                    </p>
                                </div>
                                <div className="lead_info">
                                    <DataUsage />
                                    <p className="data">
                                        {SINGLE_LEAD?.lead_type}
                                    </p>
                                </div>
                                <div className="lead_info">
                                    <DataUsage />
                                    <p className="data">
                                        {SINGLE_LEAD?.source}
                                    </p>
                                </div>
                                <div className="lead_info">
                                    <DataUsage />
                                    <p className="data">
                                        {SINGLE_LEAD?.preferred_language}
                                    </p>
                                </div>
                            </div>
                        </LeadInfoStyled>
                    </Grid>
                    <Grid item md={8}>
                        <Box sx={{ width: "100%", typography: "body1" }}>
                            <TabContext value={value}>
                                <Box>
                                    <TabList
                                        onChange={handleChange}
                                        aria-label="lab API tabs example"
                                    >
                                        <Tab label="Solutions" value="1" />
                                        <Tab label="Contracts" value="2" />
                                    </TabList>
                                </Box>
                                <TabPanel value="1">
                                    <Grid container columns={12} spacing={2}>
                                        {SOLUTIONS?.map((item) => (
                                            <Grid item md={4} key={item.id}>
                                                <Card key={item.id}>
                                                    <CardContent>
                                                        <Typography
                                                            sx={{
                                                                fontSize: 14,
                                                            }}
                                                            color="text.secondary"
                                                            gutterBottom
                                                        >
                                                            {item.id}
                                                        </Typography>
                                                        <Typography
                                                            variant="h5"
                                                            component="div"
                                                        >
                                                            {item.panels}
                                                        </Typography>
                                                        <Typography
                                                            sx={{ mb: 1.5 }}
                                                            color="text.secondary"
                                                        >
                                                            {item.status}
                                                        </Typography>
                                                        <Typography variant="body2">
                                                            {
                                                                item.installation_type
                                                            }
                                                        </Typography>
                                                    </CardContent>
                                                    <CardActions>
                                                        <Button size="small">
                                                            <a
                                                                href={
                                                                    item.pdf_path
                                                                }
                                                                target="_blank"
                                                            >
                                                                See Solution
                                                            </a>
                                                        </Button>
                                                    </CardActions>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="2">
                                    <Grid container columns={12} spacing={2}>
                                        {CONTRACT?.map((item) => (
                                            <Grid item md={4} key={item.id}>
                                                <Card key={item.id}>
                                                    <CardContent>
                                                        <Typography
                                                            sx={{
                                                                fontSize: 14,
                                                            }}
                                                            color="text.secondary"
                                                            gutterBottom
                                                        >
                                                            {item.id}
                                                        </Typography>
                                                        <Typography
                                                            variant="h5"
                                                            component="div"
                                                        >
                                                            Contract
                                                        </Typography>
                                                        {/* <Typography sx={{ mb: 1.5 }} color="text.secondary">
                            {item.status}
                          </Typography> */}
                                                        {/* <Typography variant="body2"></Typography> */}
                                                    </CardContent>
                                                    <CardActions>
                                                        <Button size="small">
                                                            <a
                                                                href={
                                                                    item.contract_url
                                                                }
                                                                target="_blank"
                                                            >
                                                                See contract
                                                            </a>
                                                        </Button>
                                                    </CardActions>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </TabPanel>
                            </TabContext>
                        </Box>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

const LeadInfoStyled = styled.div`
    padding: 2rem;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 1rem;
    min-height: 350px;
    margin: 1rem;
    background: #f9f9f9;
    .data {
        .heading {
            text-align: center;
            svg {
                font-size: 5.5rem;
                margin: 1rem 0;
                color: var(--light-blue);
            }
        }
        .lead_info {
            display: flex;
            align-items: center;
            margin: 1rem 0;
            svg {
                margin: 0 0.5rem 0 0;
                color: var(--gray);
                font-size: 1.8rem;
            }
            .data {
                color: var(--gray);
                font-weight: 600;
            }
        }
    }
`;

export default LeadInfo;
